'use client';

import { PayloadIcon } from "@payloadcms/ui";
import Link from "next/link";
import { PreviewLink } from "./preview-links";
import { useEffect, useState } from "react";
import clsx from "clsx";

interface ClientBarProps {
  userName: string;
  enterPreview: () => void;
  exitPreview: () => void;
  isPreviewMode: boolean;
};

const ClientBar = ({ userName, enterPreview, exitPreview, isPreviewMode }: ClientBarProps) => {
  const [openDetailRow, setOpenDetailRow] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    if (process) {
      setCurrentUrl(window.location.hostname);
    }
  }, []);

  const Dashboard = () => (
    <Link href={`${process.env.NEXT_PUBLIC_PAYLOAD_URL}/admin`} target='_blank'>
      Admin Dashboard →
    </Link>
  );

  const toggleDetailRow = () => {
    setOpenDetailRow(prevState => !prevState);
  };

  return (
    <>
      <div className='admin-toggle' onClick={toggleDetailRow}>
        <PayloadIcon fill='var(--admin__toggle__logo__color)' />
      </div>
      <div className={clsx('admin-bar-row', openDetailRow && 'is-active')}>
        <div className="preview-content-wrapper">
          <ul>
            <li><b>User:</b> {userName}</li>
            <li><b>Preview:</b> {isPreviewMode ? 'Active' : 'Inactive'}</li>
            <li><b>URL:</b> {currentUrl}</li>
            </ul>
        </div>
        <div className="preview-link-wrapper">
          <Dashboard />
          <PreviewLink enterPreview={enterPreview} exitPreview={exitPreview} isPreviewModeServer={isPreviewMode} />
        </div>
      </div>
    </>
  )
};

export { ClientBar };